import { Autocomplete, TextField } from "@mui/material";
import { Field } from "react-final-form";

export default function DataFilterTextField({
    name,
    label,
    defaultValue,
    required = false,
    databaseFilter = false,
    autocompleteOptions = [],
    doFilter,
    sx
}) {
    return (
        <Field name={name}>
            {(props) => (
                <Autocomplete
                    freeSolo
                    getOptionLabel={(option) => option + ""}
                    options={autocompleteOptions}
                    value={props.input.value}
                    onChange={(event, value) => {
                        // Necessário para passar os valores do MUI para o Final Form.
                        props.input.onChange(value);
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={label}
                            defaultValue={defaultValue}
                            variant="standard"
                            sx={{ mt: 1 }}
                            error={props.meta.error && props.meta.touched}
                            helperText={props.meta.touched ? props.meta.error : ""}
                            onChange={(event, value) => {
                                props.input.onChange(value);
                            }}
                        />
                    )}
                    sx={{ display: "inline-block", width: "100%", ...sx }}
                />
            )}
        </Field>
    );
}
